import CryptoJS from "crypto-js";
import logging from "app/shared/utils/logging";

const { AES, enc} = CryptoJS;
// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
const KEY = `${process.env.REACT_APP_ENCRYPTION_KEY}`;
const ENABLE_ENCRYPT = (process.env.REACT_APP_ENABLE_ENCRYPT !== "false");

export const encrypt = (data: string): string => {
    if (ENABLE_ENCRYPT) {
        try {
            return AES.encrypt(data, KEY).toString();
        } catch (e) {
            logging.debug("_ENCRYPT_ERR", `Encryption Failed`, e);
        }
    }
    return data;
};

export const decrypt = (encryptedData: string): string => {
    if (ENABLE_ENCRYPT) {
        try {
            return AES.decrypt(encryptedData.toString(), KEY).toString(enc.Utf8);
        } catch (e) {
            logging.debug("_ENCRYPT_ERR", `Decryption Failed`, e);
        }
    }
    return encryptedData;
};

export const getKey = (key: string) => {
    try {
        const val = window.sessionStorage.getItem(key);
        if (ENABLE_ENCRYPT) {
            return (val) ? decrypt(val) : null;
        }
        return val || null;
    } catch (e) {
        logging.debug("_ENCRYPT_ERR", `Issue getting value for key${key}`, e);
    }
    return null;
};

export const setKey = (key: string, value: string) => {
    try {
        if (ENABLE_ENCRYPT) {
            const encryptVal = encrypt(value);
            window.sessionStorage.setItem(key, encryptVal);
        } else {
            window.sessionStorage.setItem(key, value);
        }
    } catch (e) {
        logging.debug("_ENCRYPT_ERR", `Issue getting value for key${key}`, e);
    }
    return null;
};

export const getKeyPersist = (key: string) => {
    try {
        const val = window.localStorage.getItem(key);
        if (ENABLE_ENCRYPT) {
            return (val) ? decrypt(val) : null;
        }
        return val || null;
    } catch (e) {
        logging.debug("_ENCRYPT_ERR", `Issue getting value for key${key}`, e);
    }
    return null;
};

export const setKeyPersist = (key: string, value: string) => {
    try {
        if (ENABLE_ENCRYPT) {
            const encryptVal = encrypt(value);
            window.localStorage.setItem(key, encryptVal);
        } else {
            window.localStorage.setItem(key, value);
        }
    } catch (e) {
        logging.debug("_ENCRYPT_PERSIST_ERR", `Issue getting value for key${key}`, e);
    }
    return null;
};

export const deleteKeyPersist = (key: string) => {
    try {
        window.localStorage.removeItem(key);
    } catch (e) {
        logging.debug("_ENCRYPT_PERSIST_ERR", `Issue getting value for key${key}`, e);
    }
    return null;
};

export const deleteKey = (key: string) => {
    try {
        window.sessionStorage.removeItem(key);
    } catch (e) {
        logging.debug("_ENCRYPT_PERSIST_ERR", `Issue getting value for key${key}`, e);
    }
    return null;
};
